import { render, staticRenderFns } from "./VersionNotification.vue?vue&type=template&id=02646a50"
import script from "./VersionNotification.vue?vue&type=script&lang=js"
export * from "./VersionNotification.vue?vue&type=script&lang=js"
import style0 from "./VersionNotification.vue?vue&type=style&index=0&id=02646a50&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports